import React from 'react';
import './NotificationBadge.css';

const NotificationBadge = ({ count, size = 'normal' }) => {
  if (!count || count <= 0) return null;

  // Limiter l'affichage à 99+
  const displayCount = count > 99 ? '99+' : count.toString();

  return (
    <span className={`notification-badge ${size}`}>
      {displayCount}
    </span>
  );
};

export default NotificationBadge;